import { Controller } from '@hotwired/stimulus'
import { loadGoogleMaps } from '../lib/google_maps'

export default class extends Controller {
  static targets = [
    'input', 'latitude', 'longitude', 'department', 'region', 'country', 'plusCode',
  ]
  static values = { apiKey: String }

  connect() {
    loadGoogleMaps(this.apiKeyValue).then(() => this.#initAutocomplete())
  }

  #initAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(this.inputTarget, {
      fields: ['formatted_address', 'geometry', 'address_components', 'plus_code'],
    })

    this.inputTarget.addEventListener('keydown', (event) => {
      if (
        event.key === 'Enter' &&
        document.querySelector(".pac-container:not([style*='display: none'])")
      ) {
        event.preventDefault()
      }
    })

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace()

      this.latitudeTarget.value = place.geometry?.location?.lat() ?? ''
      this.longitudeTarget.value = place.geometry?.location?.lng() ?? ''

      if (this.hasPlusCodeTarget) {
        this.plusCodeTarget.value = place.plus_code?.global_code ?? ''
      }

      const components = place.address_components ?? []

      this.departmentTarget.value = this.#findComponent(components, 'administrative_area_level_2')
      this.regionTarget.value = this.#findComponent(components, 'administrative_area_level_1')
      this.countryTarget.value = this.#findComponent(components, 'country')
    })
  }

  #findComponent(components, type) {
    return components.find((c) => c.types.includes(type))?.long_name ?? ''
  }
}
